export default "varying vec2 v_uv;\nuniform sampler2D textureToDisplay;\n\nvoid main() {\n  gl_FragColor = texture2D(textureToDisplay, v_uv);\n}"